import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { Formik, Form as Form } from 'formik';
import { Grid, Button, TextField, Box, darken, FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import { addLoadingGlobal, addMessage, removeLoadingGlobal } from "src/actions";
import ManagerApi from 'src/services/managerApi';

const useStyles = makeStyles({
    submitButton: {
        backgroundColor: '#ff367d !important',
        color: '#ffffff !important',
        '&:hover': {
            backgroundColor: `${darken('#ff367d', 0.1)} !important`,
        },
    },
});

export const ContactForm = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [showForm, setShowForm] = useState(false);
    const [textareaKey, setTextareaKey] = useState(uuidv4());
    const [contactForm, setContactForm] = useState({
        fields: [],
    });

    const contactFormApi = new ManagerApi('/contactform');
    const contactFormContacApi = new ManagerApi('/contactform/contact');

    async function fetchContactForm() {
        try {
            const response = await contactFormApi.get(props.contactFormId).catch(error => {
                throw error;
            });
            if (response.data.success) {
                setContactForm(response.data.content);
            }
        } catch (error) {
            dispatch(addMessage(error.response.data.message, 'error'));
        }
    }

    const initialValues = {};

    const initialValueByType = {
        textarea: '',
        text: '',
        select: '',
        date: '',
        email: '',
    }

    contactForm.fields.map((field, i) => {
        initialValues[field.id] = initialValueByType[field.type];
    })

    function validateTypeEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && regex.test(email)) {
            return true;
        }
        return false;
    }

    function validateForm(values) {
        let error = '';
        contactForm.fields.forEach((field, index) => {
            if (field.required && !values[field.id]) {
                error = `Campo ${field.placeholder} obrigatório.`;
            }
            if (field.type === 'email' && !validateTypeEmail(values[field.id])) {
                error = `Campo ${field.placeholder} não é um email válido.`;
            }
        });

        if (error) {
            dispatch(addMessage(error, 'error'))
            return false;
        }
        return true;
    };

    const handleSubmit = (values, { resetForm }) => {
        if (validateForm(values)) {
            const data = {
                contactForm: contactForm.id,
                conversion_url: window.location.href,
                fields: Object.entries(values).map(([id, value]) => ({
                    id,
                    value,
                }))
            };
            const requestId = uuidv4();

            setTextareaKey(uuidv4());

            resetForm({ values: initialValues })

            dispatch(addLoadingGlobal(requestId));

            contactFormContacApi
                .post(data)
                .then(response => {
                    dispatch(removeLoadingGlobal(requestId));

                    if (response.data.success) {
                        resetForm({ values: initialValues })
                        dispatch(addMessage('Mensagem enviada com sucesso.', 'success'));
                    } else {
                        dispatch(addMessage( 'Erro', 'error'));
                    }
                })
                .catch(() => {
                    dispatch(addMessage('Erro', 'error'));
                    dispatch(removeLoadingGlobal(requestId));
                });
        }
        return false;
    };

    useEffect(() => {
        fetchContactForm();
    }, []);

    useEffect(() => {
        if (contactForm.id && contactForm.fields.length) {
            setShowForm(true);
        }
    }, [contactForm]);

    if (!showForm) {
        return <></>;
    }

    return (
        <Box>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {(formikProps) => {
                    const {
                        values,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    } = formikProps;

                    return (
                        <Form onSubmit={handleSubmit}>
                            <Grid
                                container
                                spacing={3}
                            >
                                {contactForm.fields?.length > 0 ? contactForm.fields.map((field, i) => (
                                    <>
                                        <Grid key={field.id} item md={field.size} xs={12}>
                                            {['text', 'email', 'date'].includes(field.type) && (
                                                <FormControl>
                                                    <TextField
                                                        placeholder={field.placeholder}
                                                        fullWidth
                                                        name={field.id}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values[field.id]}
                                                        InputLabelProps={{
                                                            shrink: values[field.id] ? true : false
                                                        }}
                                                    />
                                                </FormControl>
                                            )}
                                            {field.type === 'textarea' && (
                                                <FormControl>
                                                    <TextField
                                                        multiline
                                                        key={textareaKey}
                                                        placeholder={field.placeholder}
                                                        fullWidth
                                                        rows={3}
                                                        name={field.id}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values[field.id]}
                                                        InputLabelProps={{
                                                            shrink: values[field.id] ? true : false
                                                        }}
                                                    />
                                                </FormControl>

                                            )}
                                            {field.type === 'select' && (
                                                <FormControl>
                                                    <TextField
                                                        name={field.id}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        value={values[field.id]}
                                                        select
                                                        displayEmpty
                                                        onBlur={handleBlur}
                                                        SelectProps={{
                                                            native: true,
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: values[field.id] ? true : false
                                                        }}
                                                    >
                                                        <option value=''>{field.placeholder}</option>
                                                        {field.options.map(option => (
                                                            <option key={option.id} value={`${option.id}`}>
                                                                {option.name}
                                                            </option>
                                                        ))}
                                                    </TextField>
                                                </FormControl>
                                            )}
                                        </Grid>
                                    </>
                                )) : []}
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="center">
                                        <Button
                                            type='submit'
                                            variant="contained"
                                            className={clsx(classes.submitButton, 'btn', 'btn-sm')}
                                        >
                                            {props.buttonText || 'Enviar'}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    )
                }}
            </Formik>
        </Box>
    )
}
